export const projects = [
  {
    id: "fablenest",
    slug: "fablenest",
    title: "FableNest",
    tagline: "An AI-powered storytelling platform for children.",
    description: "Generates personalized bedtime stories with dynamic narratives, character customization, and voice synthesis. Designed to create engaging and calming experiences for kids while exploring scalable AI content generation.",
    platform: "iOS & iPadOS",
    role: "Solo Creator",
    timeline: "Ongoing",
    status: "Published",
    year: "2024",
    accent: "#C084FC",
    tags: ["SwiftUI", "AI Content Gen", "Voice Synthesis", "Mobile-First UX"],
    image: "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=1200&h=800&fit=crop",
    links: {
      appStore: "#",
      sourceCode: null
    },
    gallery: [
      { url: "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=800&h=600&fit=crop", alt: "Dynamic story generation" },
      { url: "https://images.unsplash.com/photo-1524578271613-d550eacf6090?w=800&h=600&fit=crop", alt: "Character customization" },
      { url: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=600&fit=crop", alt: "Voice synthesis player" }
    ]
  },
  {
    id: "transfo",
    slug: "transfo",
    title: "Transfo",
    tagline: "Transform, don't write. A BYOK clipboard AI that lives in the macOS menu bar.",
    taglineTr: "Yazma, dönüştür. macOS menü çubuğunda yaşayan, kendi anahtarınla çalışan pano AI'ı.",
    description: "Copy text, press ⌥Space, pick a recipe, and the transformed text is back on your clipboard. Thirty recipes across writing, code, product and analysis, running on your own OpenAI, OpenRouter or Gemini key. No server, no telemetry, no subscription.",
    descriptionTr: "Metni kopyala, ⌥Space'e bas, tarifi seç; dönüştürülmüş metin panoya geri gelsin. Yazım, kod, ürün ve analiz alanlarında otuz tarif; kendi OpenAI, OpenRouter ya da Gemini anahtarınla çalışır. Sunucu yok, telemetri yok, abonelik yok.",
    platform: "macOS",
    role: "Solo Creator",
    roleTr: "Tek geliştirici",
    timeline: "Active",
    timelineTr: "Aktif",
    status: "In Development",
    statusTr: "Geliştiriliyor",
    year: "2026",
    accent: "#60A5FA",
    featured: true,
    metrics: [
      { label: "Recipes", labelTr: "Tarif", value: "30" },
      { label: "Tests green", labelTr: "Yeşil test", value: "339" },
      { label: "Eval cases", labelTr: "Eval senaryosu", value: "151" },
      { label: "Telemetry", labelTr: "Telemetri", value: "None" }
    ],
    tags: ["SwiftUI", "AppKit", "BYOK", "MCP Server", "Lemon Squeezy", "Sparkle"],
    image: "/img/projects/transfo.jpg",
    imageWebp: "/img/projects/transfo.webp",
    links: {
      website: "https://www.transfo.dev",
      appStore: null,
      sourceCode: null
    },
    gallery: [
      { url: "/img/projects/transfo.jpg", alt: "Transfo website and product overview" },
      { url: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&h=600&fit=crop", alt: "Recipe catalogue" },
      { url: "https://images.unsplash.com/photo-1484417894907-623942c8ee29?w=800&h=600&fit=crop", alt: "Keyboard-driven workflow" }
    ]
  },
  {
    id: "focusscope",
    slug: "focusscope",
    title: "FocusScope",
    tagline: "Category-based focus tracking combining Pomodoro and time analytics.",
    description: "Helps users track how they spend their time across different focus categories. Provides deep insights through a clean dashboard, seamless macOS menu bar integration, and behavior-driven lightweight workflows.",
    platform: "macOS & iOS",
    role: "Solo Creator",
    timeline: "Completed",
    status: "Published",
    year: "2023",
    accent: "#FBBF24",
    tags: ["SwiftUI", "macOS Menu Bar", "Time Analytics", "Behavior-Driven Design"],
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&h=800&fit=crop",
    links: {
      appStore: "#",
      sourceCode: null
    },
    gallery: [
      { url: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=600&fit=crop", alt: "Time analytics dashboard" },
      { url: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop", alt: "Category breakdown" },
      { url: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop", alt: "Menu bar integration" }
    ]
  },
  {
    id: "pomocart",
    slug: "pomocart",
    title: "PomoCart",
    tagline: "A focus timer that turns attention into currency you actually spend.",
    taglineTr: "Dikkati, gerçekten harcadığınız bir para birimine çeviren odak zamanlayıcısı.",
    description: "Every focused minute becomes a Focus Coin, and coins buy rewards the user defines themselves. Built for adults and students with ADHD: no punishment mechanics, no shame on a broken streak. One Supabase project and one economy across web, iOS, Android, Apple Watch and Wear OS.",
    descriptionTr: "Odaklanılan her dakika bir Focus Coin'e dönüşür ve coinler kullanıcının kendi tanımladığı ödüllere harcanır. DEHB'li yetişkinler ve öğrenciler için tasarlandı: ceza mekaniği yok, kırılan seride utandırma yok. Web, iOS, Android, Apple Watch ve Wear OS'ta tek Supabase projesi ve tek ekonomi.",
    platform: "iOS · Android · Web",
    role: "Solo Creator",
    roleTr: "Tek geliştirici",
    timeline: "Active",
    timelineTr: "Aktif",
    status: "In Development",
    statusTr: "Geliştiriliyor",
    year: "2026",
    accent: "#F472B6",
    featured: true,
    metrics: [
      { label: "Platforms", labelTr: "Platform", value: "5" },
      { label: "Levels", labelTr: "Seviye", value: "12" },
      { label: "Localised keys", labelTr: "Çeviri anahtarı", value: "279" },
      { label: "Penalties", labelTr: "Ceza", value: "0" }
    ],
    tags: ["SwiftUI", "Kotlin Compose", "Supabase", "Live Activity", "Wear OS", "Gamification"],
    image: "/img/projects/pomocart.jpg",
    imageWebp: "/img/projects/pomocart.webp",
    links: {
      website: "https://pomocart.com",
      appStore: null,
      sourceCode: null
    },
    gallery: [
      { url: "/img/projects/pomocart.jpg", alt: "PomoCart onboarding with custom rewards" },
      { url: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800&h=600&fit=crop", alt: "Dopamine store" },
      { url: "https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=800&h=600&fit=crop", alt: "Streaks and quests" }
    ]
  },
  {
    id: "dalga",
    slug: "dalga",
    title: "Dalga",
    tagline: "Quit smoking or cut down first, with help that arrives the second a craving hits.",
    taglineTr: "Sigarayı bırak ya da önce azalt; kriz geldiği an yanında olan yardım.",
    description: "A quit-smoking app for iPhone and Apple Watch. One tap on Craving starts breathing and a five-minute craving timer on the Lock Screen and in the Dynamic Island. A slip is a data point, not a reset: smoke-free days, money saved and the longest streak stay. No account, and every record stays on the device.",
    descriptionTr: "iPhone ve Apple Watch için sigara bırakma uygulaması. Kriz'e tek dokunuş nefesi ve beş dakikalık kriz zamanlayıcısını kilit ekranında ve Dynamic Island'da başlatır. Bir tane içtin diye biriktirdiklerin silinmez: sigarasız günler, biriken para ve en uzun seri yerinde kalır. Hesap yok, tüm kayıtlar cihazda kalır.",
    platform: "iOS · watchOS",
    role: "Solo Creator",
    roleTr: "Tek geliştirici",
    timeline: "Active",
    timelineTr: "Aktif",
    status: "In Development",
    statusTr: "Geliştiriliyor",
    year: "2026",
    accent: "#5ED3C1",
    featured: true,
    metrics: [
      { label: "Account needed", labelTr: "Gereken hesap", value: "0" },
      { label: "Languages", labelTr: "Dil", value: "TR · EN" },
      { label: "Craving timer", labelTr: "Kriz zamanlayıcısı", value: "5 min" },
      { label: "Data on device", labelTr: "Cihazda kalan veri", value: "100%" }
    ],
    tags: ["SwiftUI", "Live Activity", "WidgetKit", "watchOS", "Rive", "Event Sourcing"],
    image: "/img/projects/nefes.jpg",
    imageWebp: "/img/projects/nefes.webp",
    links: {
      website: "https://www.alperkirmizi.com/dalga",
      appStore: null,
      sourceCode: null
    },
    gallery: [
      { url: "/img/projects/nefes.jpg", alt: "Dalga: craving help, home and a passed craving" }
    ]
  },
  {
    id: "sima",
    slug: "sima",
    title: "Sima",
    tagline: "A face care and wudu companion for older adults, in large type and with a voice.",
    taglineTr: "Yaşlılar için büyük yazılı ve sesli yüz bakımı ve abdest yardımcısı.",
    description: "An iPhone app for older adults. The front camera looks at the face and says, in one word and a score out of 100, how clean and bright it looks today compared with the person's own earlier days, never with anyone else. A step-by-step wudu guide with drawings for women and men, care steps and a daily reminder sit beside it. Large text, one task per screen and a Listen button everywhere. The photo is processed on the phone and never leaves it.",
    descriptionTr: "Yaşlı kullanıcılar için bir iPhone uygulaması. Ön kamera yüze bakar ve yüzün bugün ne kadar temiz ve aydınlık göründüğünü, kişinin kendi önceki günleriyle kıyaslayarak tek kelime ve 100 üzerinden bir puanla söyler; kimseyle sıralamaz. Yanında kadın ve erkek çizimli, adım adım abdest rehberi, bakım adımları ve günlük hatırlatma var. Büyük yazı, her ekranda tek iş ve her ekranda Dinle düğmesi. Fotoğraf telefonda işlenir ve telefondan çıkmaz.",
    platform: "iOS",
    role: "Solo Creator",
    roleTr: "Tek geliştirici",
    timeline: "Active",
    timelineTr: "Aktif",
    status: "In Development",
    statusTr: "Geliştiriliyor",
    year: "2026",
    accent: "#F4C23C",
    featured: true,
    metrics: [
      { label: "Photos leaving the phone", labelTr: "Telefondan çıkan fotoğraf", value: "0" },
      { label: "Smallest text", labelTr: "En küçük yazı", value: "17 pt" },
      { label: "Touch targets", labelTr: "Dokunma hedefi", value: "60 pt" },
      { label: "Account needed", labelTr: "Gereken hesap", value: "0" }
    ],
    tags: ["SwiftUI", "Vision", "AVFoundation", "SwiftData", "Accessibility"],
    image: "/img/projects/sima.jpg",
    imageWebp: "/img/projects/sima.webp",
    links: {
      website: "https://www.alperkirmizi.com/sima",
      appStore: null,
      sourceCode: null
    },
    gallery: [
      { url: "/img/projects/sima.jpg", alt: "Sima: scan guide, today's result and a wudu step" }
    ]
  },
  {
    id: "english-time",
    slug: "english-time",
    title: "English Time",
    tagline: "A CEFR-structured English course built for one teacher and her students.",
    taglineTr: "Bir öğretmen ve öğrencileri için kurulmuş, CEFR yapılı İngilizce kursu.",
    description: "An installable learning app with CEFR levels, unit-based lessons, vocabulary with spaced review, grammar lessons, quizzes and a placement test, plus a teacher panel that manages every piece of content without a deploy. Built as a personal project for a teacher, and running live inside this site.",
    descriptionTr: "CEFR seviyeleri, ünite tabanlı dersler, aralıklı tekrarlı kelime çalışması, gramer dersleri, quiz'ler ve seviye tespit sınavı içeren kurulabilir bir öğrenme uygulaması; ayrıca tüm içeriği deploy gerektirmeden yöneten bir öğretmen paneli. Bir öğretmen için kişisel proje olarak yapıldı ve bu sitenin içinde canlı çalışıyor.",
    platform: "Web · PWA",
    role: "Solo Creator",
    roleTr: "Tek geliştirici",
    timeline: "Live",
    timelineTr: "Canlı",
    status: "Published",
    statusTr: "Yayında",
    year: "2026",
    accent: "#34D399",
    featured: true,
    liveAppPath: "/english-time",
    metrics: [
      { label: "CEFR levels", labelTr: "CEFR seviyesi", value: "6" },
      { label: "Exercise types", labelTr: "Alıştırma türü", value: "7" },
      { label: "Teacher-managed", labelTr: "Öğretmen yönetimli", value: "100%" },
      { label: "Install", labelTr: "Kurulum", value: "PWA" }
    ],
    tags: ["React", "PWA", "FastAPI", "MongoDB", "CEFR", "Spaced Repetition"],
    image: "/img/projects/english-time.jpg",
    imageWebp: "/img/projects/english-time.webp",
    links: { website: null, appStore: null, sourceCode: null },
    gallery: [
      { url: "/img/projects/english-time.jpg", alt: "English Time entry screen" },
      { url: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&h=600&fit=crop", alt: "Vocabulary review" },
      { url: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&h=600&fit=crop", alt: "Teacher panel" }
    ]
  }
];